import { DataNavigationState, StartInfo } from 'plugin-live-exploratory-viz/src/data-navigation/types/widget'
import {
    getMultiChannelIdentifierWithLayerPrefix,
    mergeMetaConfig,
    realtimeSpan
} from 'plugin-live-exploratory-viz/src/data-navigation/reducer/utils'
import { getMultiChannelIdentifier } from 'plugin-live-exploratory-viz/src/services/channel/utils'
import { shouldDelayClearState } from 'plugin-live-exploratory-viz/src/data-navigation/reducer'

export function onStartQuery(message: StartFlowMessage<StartInfo>, state: DataNavigationState): DataNavigationState {
    const series = {}
    let config = {}
    const shouldClearSeries = !!shouldDelayClearState?.enabled

    Object.keys(message.events.info.__assetConfig.channels).forEach(mnemonic => {
        const multiChannelIdentifier = getMultiChannelIdentifier(message.events.info.__assetId, mnemonic)
        const multiChannelIdentifierWithLayerPrefix = getMultiChannelIdentifierWithLayerPrefix(
            message.layer,
            multiChannelIdentifier
        )
        series[multiChannelIdentifierWithLayerPrefix] = {
            data: [],
            domain: [0, 0]
        }

        config = mergeMetaConfig(message.events?.info, state.config, message.layer)
    })

    return {
        series: { ...state.series, ...(shouldClearSeries ? {} : series) },
        span: [0, Number.MAX_SAFE_INTEGER],
        realtime: realtimeSpan(message.events?.info?.span),
        config: config,
        shouldDelayClearState: shouldDelayClearState
    }
}
